module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.a35720c2.woff";